import index from "@/pages/usercenter/businessCards/List";

export default [
    {
        path: 'company-card-record/:itemId?/:type?',
        name: 'company-card-record',
        meta: {
            title: '查看名片统计-单位管理'
        },
        component: index,
    },

]


// WEBPACK FOOTER //
// ./src/router/company/card/index.js